import { amplitudeEvent } from 'lib/amplitude'

export const COACH_NOTE_SOURCES = {
  STUDENT_NOTES_TAB: 'student_notes_tab',
  SESSION_DETAILS_DIALOG: 'session_details_dialog',
  SESSION_ROW: 'session_row',
  SESSION_MENU: 'session_menu',
}

const baseNoteProperties = ({
  noteId,
  notableType,
  source,
  isPrivate,
  studentId,
  sessionId,
}) => ({
  note_id: noteId ?? null,
  notable_type: notableType ?? null,
  source,
  is_private: isPrivate ?? null,
  student_id: studentId ?? null,
  session_id: sessionId ?? null,
  path: window.location.pathname,
  url: window.location.href,
})

export const trackCoachNotesTabClicked = studentId => {
  amplitudeEvent('coach-notes-tab-clicked', {
    student_id: studentId ?? null,
    path: window.location.pathname,
    url: window.location.href,
  })
}

export const trackCoachSessionNoteEntryClicked = ({
  studentId,
  sessionId,
  source,
  hasExistingNote,
}) => {
  amplitudeEvent('coach-session-note-entry-clicked', {
    student_id: studentId ?? null,
    session_id: sessionId ?? null,
    source,
    has_existing_note: Boolean(hasExistingNote),
    path: window.location.pathname,
    url: window.location.href,
  })
}

export const trackCoachNoteCreated = ({
  noteId,
  notableType,
  source,
  isPrivate,
  studentId,
  sessionId,
}) => {
  amplitudeEvent(
    'coach-note-created',
    baseNoteProperties({
      noteId,
      notableType,
      source,
      isPrivate,
      studentId,
      sessionId,
    }),
  )
}

export const trackCoachNoteUpdated = ({
  noteId,
  notableType,
  source,
  isPrivate,
  studentId,
  sessionId,
}) => {
  amplitudeEvent(
    'coach-note-updated',
    baseNoteProperties({
      noteId,
      notableType,
      source,
      isPrivate,
      studentId,
      sessionId,
    }),
  )
}

export const trackCoachNoteDeleted = ({
  noteId,
  notableType,
  source,
  isPrivate,
  studentId,
  sessionId,
}) => {
  amplitudeEvent(
    'coach-note-deleted',
    baseNoteProperties({
      noteId,
      notableType,
      source,
      isPrivate,
      studentId,
      sessionId,
    }),
  )
}
